import { configureStore, combineReducers } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import authSlice from '@store/slices/auth.slice'
import articleSlice from '@editor/store/slices/article.slice'
import articleVersionSlice from '@editor/store/slices/articleVersion.slice'
import audioSlice from '@editor/store/slices/audio.slice'
import jobSlice from '@editor/store/slices/job.slice'
import ssmlSlice from '@editor/store/slices/ssml.slice'
import tagSlice from '@editor/store/slices/tag.slice'
import voiceSlice from '@editor/store/slices/voice.slice'
import templateSlice from '@editor/store/slices/template.slice'
import * as Sentry from "@sentry/react"

const rootReducer = combineReducers({
  auth: authSlice,
  articles: articleSlice,
  articleVersions: articleVersionSlice,
  audios: audioSlice,
  jobs: jobSlice,
  ssmls: ssmlSlice,
  tags: tagSlice,
  voices: voiceSlice,
  templates: templateSlice,
})

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  enhancers: (getDefaultEnhancers) => [
    ...getDefaultEnhancers,
    sentryReduxEnhancer
  ],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['audio/downloadAudio/fulfilled', 'persist/PERSIST'], // Ignore this action type
      },
    }),
})

export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
